import { action } from 'satcheljs';

export interface InlineFeedbackDialogResponseProps {
    sessionId: string;
    inlineFeedbackResponseText: string;
    inlineFeedbackResponseCategories: string[];
    isContentDonated: boolean;
    isUVTicketCreated: boolean;
    odsResponse: string;
}

export const logInlineFeedbackDialogResponse = action(
    'logInlineFeedbackDialogResponse',
    (inlineFeedbackDialogResponse: InlineFeedbackDialogResponseProps) =>
        inlineFeedbackDialogResponse
);
